export const API_URL = process.env.REACT_APP_API_URL
// export const API_URL = 'http://127.0.0.1:8000'

export const SITE_LOGO = 'ABSITE'
// export const WP_URL = process.env.REACT_APP_WP_URL
export const WP_URL = 'http://18.153.105.128/wp-json'
export const CHAT_STREAM_URL = process.env.REACT_APP_CHAT_STREAM_URL
export const INCREMENT_LIMIT = 4
export const DECREMENT_LIMIT = -2
